// extracted by mini-css-extract-plugin
export default {"form":"contactsForm_form__-yBnK","label":"contactsForm_label__LIVBw","input":"contactsForm_input__+uh9n","btn":"contactsForm_btn__Y0lD1"};